import { useEffect, useRef, useState } from 'react';

export const useElementVisibility = (options = {}) => {
  const elementRef = useRef(null);
  const [isHidden, setIsHidden] = useState(false);

  useEffect(() => {
    if (!elementRef.current) return;

    const observer = new IntersectionObserver(([entry]) => {
      // Element is hidden (scrolled out of view) when not intersecting
      setIsHidden(!entry.isIntersecting);
    }, {
      threshold: 0,
      ...options
    });

    observer.observe(elementRef.current);

    return () => {
      observer.disconnect();
    };
  }, [options]);

  return { elementRef, isHidden };
};